export const INITIAL_VALUES = {
  activeProcessess: "",
  lawAreas: "",
  reasonSign: [],
  reasonDetails: "",
  workContext: "",
  workContextDetails: "",
  workForceSize: "",
};
